(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ui-toast')) {
    customElements.define(
      'ui-toast',
      class UiToast extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.querySelector('[data-feedback-close]')?.addEventListener('click', () => this.hide())
        }

        show() {
          this.hidden = false
          this.setAttribute('aria-live', 'polite')
        }

        hide() {
          this.hidden = true
        }
      },
    )
  }

  if (!customElements.get('ui-feedback')) {
    customElements.define(
      'ui-feedback',
      class UiFeedback extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.querySelector('[data-feedback-close]')?.addEventListener('click', () => {
            this.hidden = true
          })
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.input = this.querySelector('input[type="number"]')
          this.addEventListener('click', this.handleClick)
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick)
        }

        handleClick = (event) => {
          const button = event.target.closest('button')
          if (!button || !this.input || button.disabled) return
          const previousValue = this.input.value
          if (button.matches('[data-quantity-minus]')) this.input.stepDown()
          if (button.matches('[data-quantity-plus]')) this.input.stepUp()
          if (this.input.value !== previousValue) {
            this.input.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ui-overlay')) {
    customElements.define(
      'ui-overlay',
      class UiOverlay extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.dialog = this.querySelector('[data-overlay-dialog]')
          this.addEventListener('click', this.handleClick)
          document.addEventListener('click', this.handleExternalClick)
          document.addEventListener('overlay:open', this.handleExternalOpen)
          this.dialog?.addEventListener('close', this.restoreFocus)
          this.dialog?.addEventListener('keydown', this.handleKeydown)
        }

        disconnectedCallback() {
          if (this.dialog?.open && this.dialog.hasAttribute('scroll-lock')) {
            const otherOpenOverlay = document.querySelector('ui-overlay dialog[open]')
            if (!otherOpenOverlay) {
              document.documentElement.classList.remove('overlay-open')
              document.body.classList.remove('overlay-open')
            }
          }
          this.removeEventListener('click', this.handleClick)
          document.removeEventListener('click', this.handleExternalClick)
          document.removeEventListener('overlay:open', this.handleExternalOpen)
          this.dialog?.removeEventListener('close', this.restoreFocus)
          this.dialog?.removeEventListener('keydown', this.handleKeydown)
          delete this.dataset.ready
        }

        handleClick = (event) => {
          if (!this.dialog) return
          const closeButton = event.target.closest('[data-overlay-close]')
          if (closeButton || event.target === this.dialog) this.dialog.close()
        }

        handleExternalClick = (event) => {
          const openButton = event.target.closest('[data-overlay-open]')
          if (!openButton || openButton.dataset.overlayOpen !== this.dialog?.id) return
          event.preventDefault()
          this.open(openButton)
        }

        handleExternalOpen = (event) => {
          if (event.detail?.id !== this.dialog?.id) return
          this.open(event.detail?.trigger)
        }

        handleKeydown = (event) => {
          if (event.key !== 'Escape' || !this.dialog?.open) return
          event.preventDefault()
          this.dialog.close()
        }

        open(trigger) {
          if (!this.dialog || this.dialog.open) return
          this.returnFocusTo = trigger || document.activeElement
          document.documentElement.classList.add('overlay-open')
          document.body.classList.add('overlay-open')
          this.dialog.showModal()
          this.dialog.querySelector('[autofocus]')?.focus()
        }

        restoreFocus = () => {
          if (!document.querySelector('dialog[open][scroll-lock]')) {
            document.documentElement.classList.remove('overlay-open')
            document.body.classList.remove('overlay-open')
          }
          this.returnFocusTo?.focus()
        }
      },
    )
  }

  if (!customElements.get('ui-popover')) {
    customElements.define(
      'ui-popover',
      class UiPopover extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          const trigger = this.querySelector('[data-popover-trigger]')
          const popover = this.querySelector('[popover]')
          if (!trigger || !popover) return
          if ('showPopover' in popover) {
            popover.addEventListener('toggle', (event) => {
              trigger.setAttribute('aria-expanded', event.newState === 'open' ? 'true' : 'false')
            })
            return
          }
          popover.hidden = true
          trigger.addEventListener('click', () => {
            popover.hidden = !popover.hidden
            trigger.setAttribute('aria-expanded', popover.hidden ? 'false' : 'true')
          })
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.form = this.querySelector('form')
          this.submitButton = this.querySelector('[data-product-submit]')
          this.variantAvailable = !this.submitButton?.disabled
          this.spinner = this.querySelector('[data-product-spinner]')
          this.message = this.querySelector('[data-product-message]')
          this.form?.addEventListener('submit', this.handleSubmit)
          this.addEventListener('variant:change', this.handleVariantChange)
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.handleSubmit)
          this.removeEventListener('variant:change', this.handleVariantChange)
          delete this.dataset.ready
        }

        handleVariantChange = (event) => {
          const variantInput = this.form?.querySelector('[data-variant-id]')
          if (variantInput) variantInput.value = event.detail.id
          this.variantAvailable = event.detail.available
          if (this.submitButton) this.submitButton.disabled = !this.variantAvailable
          const buttonLabel = this.submitButton?.querySelector('.ui-button__label')
          if (buttonLabel) buttonLabel.textContent = this.variantAvailable ? this.dataset.addLabel : this.dataset.soldOutLabel
        }

        handleSubmit = async (event) => {
          if (!this.form || !window.fetch || this.submitting) return
          event.preventDefault()
          this.submitting = true
          this.setLoading(true)
          this.showMessage('')

          try {
            const endpoint = this.form.action.endsWith('.js') ? this.form.action : `${this.form.action}.js`
            const formData = this.buildFormData()
            const submittedProperties = this.getSubmittedProperties(formData)
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            })
            const data = await response.json()
            if (!response.ok) throw new Error(data.description || data.message || this.dataset.errorMessage)
            if (!this.propertiesMatch(data.properties, submittedProperties)) throw new Error(this.dataset.propertyErrorMessage)
            await this.verifyCartProperties(data, submittedProperties)
            this.showMessage(this.dataset.successMessage)
            this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }))
          } catch (error) {
            this.showMessage(error.message || this.dataset.errorMessage, true)
          } finally {
            this.submitting = false
            this.setLoading(false)
          }
        }

        setLoading(loading) {
          if (this.submitButton) {
            this.submitButton.disabled = loading || !this.variantAvailable
            this.submitButton.setAttribute('aria-busy', loading ? 'true' : 'false')
          }
          if (this.spinner) this.spinner.hidden = !loading
        }

        buildFormData() {
          const formData = new FormData(this.form)
          const propertyControls = [...this.form.elements].filter((control) => control.name?.startsWith('properties['))

          propertyControls.forEach((control) => {
            const isCheckable = control.type === 'checkbox' || control.type === 'radio'
            if (control.disabled || (isCheckable && !control.checked)) return
            if (!formData.has(control.name)) formData.append(control.name, control.value)
          })

          return formData
        }

        getSubmittedProperties(formData) {
          const submittedProperties = {}

          formData.forEach((value, name) => {
            const propertyMatch = name.match(/^properties\[(.+)\]$/)
            if (!propertyMatch || typeof value !== 'string' || value === '') return
            submittedProperties[propertyMatch[1]] = value
          })

          return submittedProperties
        }

        propertiesMatch(returnedProperties, submittedProperties) {
          return Object.entries(submittedProperties).every(([name, value]) => String(returnedProperties?.[name] ?? '') === value)
        }

        async verifyCartProperties(addedItem, submittedProperties) {
          if (Object.keys(submittedProperties).length === 0) return

          const root = window.Shopify?.routes?.root || '/'
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
          if (!response.ok) throw new Error(this.dataset.propertyErrorMessage)

          const cartData = await response.json()
          const addedCartLine = cartData.items.find((item) => item.key === addedItem.key)
          if (!addedCartLine || !this.propertiesMatch(addedCartLine.properties, submittedProperties)) {
            throw new Error(this.dataset.propertyErrorMessage)
          }
        }

        showMessage(text, isError = false) {
          if (!this.message) return
          this.message.textContent = text
          this.message.hidden = !text
          this.message.classList.toggle('is-error', isError)
          this.message.setAttribute('role', isError ? 'alert' : 'status')
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class ProductGallery extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.track = this.querySelector('[data-gallery-track]')
          this.slides = [...this.querySelectorAll('[data-gallery-slide]')]
          this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')]
          this.addEventListener('click', this.handleClick)
          this.thumbnailGroup = this.querySelector('[data-gallery-thumbnails]')
          this.thumbnailGroup?.addEventListener('keydown', this.handleThumbnailKeydown)
          if ('IntersectionObserver' in window && this.track) {
            this.observer = new IntersectionObserver(this.handleIntersect, { root: this.track, threshold: 0.6 })
            this.slides.forEach((slide) => this.observer.observe(slide))
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick)
          this.thumbnailGroup?.removeEventListener('keydown', this.handleThumbnailKeydown)
          this.observer?.disconnect()
          delete this.dataset.ready
        }

        handleClick = (event) => {
          const thumbnail = event.target.closest('[data-gallery-thumbnail]')
          if (!thumbnail) return
          this.showSlide(thumbnail)
        }

        handleThumbnailKeydown = (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
          const currentIndex = this.thumbnails.indexOf(event.target.closest('[data-gallery-thumbnail]'))
          if (currentIndex < 0) return
          event.preventDefault()
          let nextIndex = currentIndex
          if (event.key === 'ArrowLeft') nextIndex = Math.max(0, currentIndex - 1)
          if (event.key === 'ArrowRight') nextIndex = Math.min(this.thumbnails.length - 1, currentIndex + 1)
          if (event.key === 'Home') nextIndex = 0
          if (event.key === 'End') nextIndex = this.thumbnails.length - 1
          this.thumbnails[nextIndex].focus()
          this.showSlide(this.thumbnails[nextIndex])
        }

        showSlide(thumbnail) {
          const slide = this.querySelector(`#${CSS.escape(thumbnail.dataset.targetId)}`)
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          slide?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' })
          this.setCurrent(slide?.dataset.mediaId)
        }

        handleIntersect = (entries) => {
          const visible = entries.find((entry) => entry.isIntersecting)
          if (visible) this.setCurrent(visible.target.dataset.mediaId)
        }

        setCurrent(mediaId) {
          this.thumbnails.forEach((thumbnail) => {
            const isCurrent = thumbnail.dataset.targetId.endsWith(`-${mediaId}`)
            if (isCurrent) thumbnail.setAttribute('aria-current', 'true')
            else thumbnail.removeAttribute('aria-current')
          })
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-product')) {
    customElements.define('share-product', class ShareProduct extends HTMLElement {
      connectedCallback() { if (this.dataset.ready) return; this.dataset.ready = 'true'; this.addEventListener('click', this.handleClick) }
      disconnectedCallback() { this.removeEventListener('click', this.handleClick); delete this.dataset.ready }
      handleClick = async (event) => {
        if (!event.target.closest('[data-share-button]')) return
        try {
          if (navigator.share) await navigator.share({ title: this.dataset.title, url: this.dataset.url })
          else { await navigator.clipboard.writeText(this.dataset.url); this.showCopied() }
        } catch (error) { if (error.name !== 'AbortError') this.showCopied(false) }
      }
      showCopied(success = true) { const status = this.querySelector('[data-share-status]'); if (!status || !success) return; status.textContent = this.dataset.copiedLabel; status.hidden = false }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return
        this.dataset.ready = 'true'
        this.target = document.getElementById(this.dataset.targetId)
        this.form = document.getElementById(this.dataset.formId)
        if (!this.target || !('IntersectionObserver' in window)) return
        this.observer = new IntersectionObserver(([entry]) => { this.hidden = entry.isIntersecting }, { threshold: 0.05 })
        this.observer.observe(this.target)
        this.form?.addEventListener('variant:change', this.handleVariantChange)
      }
      disconnectedCallback() { this.observer?.disconnect(); this.form?.removeEventListener('variant:change', this.handleVariantChange); delete this.dataset.ready }
      handleVariantChange = (event) => {
        const label = this.querySelector('[data-sticky-variant]')
        const price = this.querySelector('.ecom-price__current')
        const button = this.querySelector('[data-sticky-submit]')
        const buttonLabel = button?.querySelector('.ui-button__label')
        if (label) label.textContent = event.detail.title
        if (price && event.detail.price) price.textContent = event.detail.price
        if (button) button.disabled = !event.detail.available
        if (buttonLabel) buttonLabel.textContent = event.detail.available ? this.dataset.addLabel : this.dataset.soldOutLabel
      }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ui-tabs')) {
    customElements.define(
      'ui-tabs',
      class UiTabs extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.tabs = [...this.querySelectorAll('[role="tab"]')]
          this.tabs.forEach((tab, index) => {
            tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1
            tab.addEventListener('click', this.selectTab)
            tab.addEventListener('keydown', (event) => this.handleKeydown(event, index))
          })
          const selected = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]
          if (selected) this.activate(selected, false)
        }

        selectTab = (event) => this.activate(event.currentTarget)

        handleKeydown(event, index) {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End']
          if (!keys.includes(event.key)) return
          event.preventDefault()
          let nextIndex = index
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length
          if (event.key === 'Home') nextIndex = 0
          if (event.key === 'End') nextIndex = this.tabs.length - 1
          this.tabs[nextIndex].focus()
          this.activate(this.tabs[nextIndex], false)
        }

        activate(activeTab, moveFocus = true) {
          this.tabs.forEach((tab) => {
            const isActive = tab === activeTab
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
            tab.tabIndex = isActive ? 0 : -1
            const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`)
            if (panel) panel.hidden = !isActive
          })
          if (moveFocus) activeTab.focus()
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-selector')) {
    customElements.define(
      'variant-selector',
      class VariantSelector extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return
          this.dataset.ready = 'true'
          this.variantInput = this.closest('form')?.querySelector('[data-variant-id]')
          if (this.variantInput) this.variantInput.disabled = false
          this.addEventListener('change', this.handleChange)
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.handleChange)
          if (this.variantInput) this.variantInput.disabled = true
          delete this.dataset.ready
        }

        handleChange = (event) => {
          const control = event.target.closest('[data-variant-option]')
          if (!control) return
          const selectedOption = control.matches('select') ? control.selectedOptions[0] : control
          const optionGroup = control.closest('[data-option-position]')
          const selectedLabel = optionGroup?.querySelector('[data-selected-value]')
          if (selectedLabel) selectedLabel.textContent = selectedOption.value

          const selectedControls = [...this.querySelectorAll('[data-option-position]')]
            .map((group) => group.querySelector('select')?.selectedOptions[0] || group.querySelector('input:checked'))
            .filter(Boolean)
          const optionValueIds = selectedControls.map((selected) => selected.dataset.optionValueId).filter(Boolean)
          const associatedProductUrl = selectedOption.dataset.productUrl
          const productUrl = associatedProductUrl || this.dataset.productUrl

          if (this.dataset.updateUrl === 'true') {
            const url = this.buildVariantUrl(productUrl, optionValueIds)
            window.location.assign(url.toString())
            return
          }

          const variantId = selectedOption.dataset.variantId
          if (!variantId) return
          this.closest('form')?.querySelector('[name="id"]')?.setAttribute('value', variantId)
          this.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: true,
              detail: { id: variantId, available: !selectedOption.disabled, title: selectedOption.value, price: selectedOption.dataset.price },
            }),
          )
        }

        buildVariantUrl(productUrl, optionValueIds) {
          const url = new URL(window.location.href)
          const targetUrl = new URL(productUrl, window.location.origin)

          url.pathname = targetUrl.pathname
          if (targetUrl.hash) url.hash = targetUrl.hash

          targetUrl.searchParams.forEach((value, key) => {
            if (key === 'option_values' || key === 'variant' || url.searchParams.has(key)) return
            url.searchParams.append(key, value)
          })

          url.searchParams.delete('option_values')
          url.searchParams.delete('variant')
          if (optionValueIds.length) url.searchParams.set('option_values', optionValueIds.join(','))

          return url
        }
      },
    )
  }
  } catch(e) { console.error(e); }
})();

})();
